import React from 'react';

export default function ThinkingIndicator() {
  return (
    <div className="percy-thinking">
      <span className="percy-thinking-paw" role="img" aria-label="paw">🐾</span>
      <span className="percy-thinking-text">Thinking...</span>
    </div>
  );
}
